import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import { useAppSelector } from "../../app/store";
import { useUpdatePinMutation } from "../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../hooks/useError";
import { toast } from "../../lib/toast";
import { CustomModalProps } from "../../types";
import CustomModal from "../ui/CustomModal";

type Props = {
  data?: any;
} & CustomModalProps;

export default function PinNumberModal({ data, handleClose, ...rest }: Props) {
  const [form] = Form.useForm();
  const { user } = useAppSelector((state) => state.auth);
  const [updatePIN, { isError, isLoading, isSuccess, error }] =
    useUpdatePinMutation();
  useError(isError, error, "PIN set fail");

  const onFinish = (value: any) => {
    const newData = {
      ...value,
      email: user?.data?.email,
    };

    updatePIN({ data: newData, id: data?.id });
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "PIN set successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <CustomModal
      {...rest}
      title="Set PIN number"
      handleClose={handleClose}
      width={500}
      footer={false}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          label="PIN Number"
          name="pin"
          validateFirst
          rules={[
            { required: true, message: "Please Enter PIN Number" },
            { min: 6, message: "PIN must be minimum 6 digits" },
          ]}
        >
          <Input placeholder="Enter PIN Number" />
        </Form.Item>

        <Space className="w-full mt-2" size={12}>
          <Button
            onClick={handleClose}
            className="normal-dark-button modal-button"
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Set
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
